import React, { useState } from 'react';
import { parseForm } from '../../../../utils/helpers/parseForm';
import { formatDate } from '../../../../utils/helpers/formatters';
import PhotoDisplay from '../PhotoDisplay';
import TicketPhotos from '../TicketPhotos';
import HookupPoints from '../HookupPoints/HookupPoints';
import './styles.scss';

const WorkLog = ({ worklog }) => {
  const {
    id,
    _id,
    hookup_points,
    long_description,
    note,
    start_time,
    start_latitude,
    start_longitude,
    end_time,
    end_latitude,
    end_longitude,
    // adjustedStart,
    response_type,
    metadata_originating_user,
    metadata_user,
    form,
    // New format properties
    start,
    end,
    responseType,
    metadata,
  } = worklog;

  // Support both formats - use new format if available, fallback to old
  const worklogId = id || _id;
  const startTime = start?.time || start_time;
  const startLat = start?.latitude || start_latitude;
  const startLon = start?.longitude || start_longitude;
  const endTime = end?.time || end_time;
  const endLat = end?.latitude || end_latitude;
  const endLon = end?.longitude || end_longitude;
  const responseTypeValue = responseType || response_type;
  const metadataUser = metadata?.user || metadata_user;
  const metadataOriginatingUser = metadata?.originatingUser || metadata_originating_user;

  const [selectedPhoto, setSelectedPhoto] = useState(false);
  const [photoComponent, setPhotoComponent] = useState(false);
  const { responseArray } = parseForm(form);
  const workLogText = responseArray.join('\n');
  const validHookupPoints = hookup_points && JSON.parse(hookup_points);
  const hasHookupPoints = validHookupPoints && Object.keys(validHookupPoints).length > 0;
  const printableLongDescription = long_description
    ? long_description
        .split(/[{ }]/)
        .reduce((array, string) => {
          const regex = /(([0-1]?[0-9])|(2[0-3])):[0-5][0-9]:[0-5][0-9]/;
          if (regex.test(string)) {
            string = string + 'ET';
          }
          array.push(string);
          return array;
        }, [])
        .join(' ')
        .replace(/&lt;br \/&gt;/g, '\n')
        .replace(/&lt;br\/&gt;/g, '\n')
    : null;
  return (
    <div className={'worklog'}>
      <div className={'worklog-header'}>
        <p>Work Log on {formatDate(endTime ?? startTime)}</p>
        {worklog.photos && (
          <button className="photo-button" onClick={() => setPhotoComponent(true)}>
            View Photos
          </button>
        )}
      </div>
      {hasHookupPoints && (
        <HookupPoints hookupPointsParsed={validHookupPoints} workLogId={worklogId} />
      )}
      <p>
        <b>Response Type</b>: {responseTypeValue}
      </p>
      <p>
        <b>Added By</b>: {metadataOriginatingUser ? metadataOriginatingUser : metadataUser}
      </p>
      <p>
        <b>Start Time</b>: {formatDate(startTime)}
      </p>
      <p>
        <b>Start Latitude</b>: {startLat ? startLat : 'N/A'}
      </p>
      <p>
        <b>Start Longitude</b>: {startLon ? startLon : 'N/A'}
      </p>
      {/* {adjustedStart && (
        <p>
          <b>Locator Adjusted Start</b>: {adjustedStart.time}
        </p>
        )} */}
      <p>
        <b>End Time</b>: {formatDate(endTime)}
      </p>
      <p>
        <b>End Latitude</b>: {endLat ? endLat : 'N/A'}
      </p>
      <p>
        <b>End Longitude</b>: {endLon ? endLon : 'N/A'}
      </p>
      <div className="worklog-text">
        {workLogText && <>{workLogText}</>}
        {note && <>{note}</>}
        {printableLongDescription && <>{printableLongDescription}</>}
      </div>
      {worklog.photos && worklog.photos.length > 0 && (
        <>
          <div
            className={photoComponent && !selectedPhoto ? 'ticket-photos' : 'ticket-photos-hidden'}
          >
            <TicketPhotos
              photos={worklog.photos}
              setPhotoComponent={setPhotoComponent}
              setSelectedPhoto={setSelectedPhoto}
            />
          </div>
          {selectedPhoto && (
            <PhotoDisplay selectedPhoto={selectedPhoto} setSelectedPhoto={setSelectedPhoto} />
          )}
        </>
      )}
    </div>
  );
};

export default WorkLog;
